<!-- 申请使用 -->
<template>
  <div class="apply-use page">
    <v-header
      :headTitle="headTitle"
      :isBack="true"
      :pageName="pageName"
      v-if="false"
    ></v-header>
    <div class="container">
      <div class="report_header">
        <div class="circle df-center">
          <img src="../../assets/images/home/i-role-min2.png" alt="" />
        </div>
        <div class="df-item-center step">
          <img
            src="../../assets/images/applyuse/i-compete.png"
            alt=""
            class="i-compete"
            v-if="step === 1"
          />
          <div
            class="number df-center"
            :class="{ number_active: step === 0 }"
            v-else
          >
            1
          </div>
          <div class="text" :class="{ active_text: step === 0 }">
            填写申请表单
          </div>
          <img src="../../assets/images/applyuse/i-right.png" alt="" />
          <div
            class="number right_number"
            :class="{ number_active: step === 1 }"
          >
            2
          </div>
          <div class="text">领取15天免费试用</div>
        </div>
      </div>
      <div class="share_wx" v-if="step === 1">
        <div class="share_wx_title">
          分享朋友圈即可立即领取<br /><span>15天</span>免费试用权益
        </div>
        <div class="share_btn df-center" @click="shareWx">分享朋友圈</div>
        <div class="df-center down_app" @click="goDownAppPath">
          <img src="../../assets/images/applyuse/i-download.png" alt="" />
          下载感控工作间APP
        </div>
      </div>
      <!-- <div class="foot_tips foot_tips_1">
        温馨提示：填写以下表单即可为医院申请开通试用或签约，
        我们会安排专属顾问与您联系
      </div> -->
      <div class="report_body" v-if="step === 0">
        <van-tabs
          v-model="applyUseIndex"
          color="#26B4FF"
          title-active-color="#26B4FF"
          title-inactive-color="#666"
          class="area_scene_sub_tab"
        >
          <div class="div" style="border-bottom: 1px solid #eee"></div>
          <van-tab title="医院试用">
            <van-form
              @submit="onSubmit"
              class="form_padding"
              ref="applyUseForm"
            >
              <div
                class="form_row df-item-center"
                @click.stop="openServicePopup(0)"
              >
                <img
                  src="../../assets/images/applyuse/i-form1.png"
                  alt=""
                  class="left_icon"
                />
                <van-field
                  v-model="applyUseForm.servicePackageName"
                  name="servicePackageName"
                  readonly
                  placeholder="请选择服务包"
                  :rules="[{ required: true, message: '' }]"
                />
                <img
                  src="../../assets/images/applyuse/i-arrow-down.png"
                  alt=""
                  class="right_icon"
                />
              </div>
              <div class="form_row df-item-center">
                <img
                  src="../../assets/images/applyuse/i-form2.png"
                  alt=""
                  class="left_icon"
                />
                <van-field
                  v-model="applyUseForm.phone"
                  :placeholder="applyTryPhoneHolder"
                  type="tel"
                  name="phone"
                  clearable
                  :rules="[{ required: true, message: '' }]"
                />
                <!--                <img src="../../assets/images/applyuse/i-arrow-down.png" alt="" class="right_icon">-->
              </div>
              <template v-if="false">
                <div class="form_row df-item-center">
                  <img
                    src="../../assets/images/applyuse/i-form2.png"
                    alt=""
                    class="left_icon"
                  />
                  <van-field
                    v-model="applyUseForm.imgCode"
                    placeholder="请输入校验码"
                    type="text"
                    name="imgCode"
                    clearable
                    :rules="[{ required: true, message: '' }]"
                  />
                  <img :src="imgCode" alt="" class="img_code" />
                </div>
              </template>
              <div class="form_row df-item-center">
                <img
                  src="../../assets/images/applyuse/i-form3.png"
                  alt=""
                  class="left_icon"
                />
                <van-field
                  v-model="applyUseForm.validCode"
                  name="validCode"
                  placeholder="请输入验证码"
                  clearable
                  :rules="[{ required: true, message: '' }]"
                />
                <div
                  class="get_code"
                  v-if="!tryCountDownShow"
                  @click="getTryCode(0)"
                >
                  获取验证码
                </div>
                <!--                <van-count-down :time="countDownTime" />-->
                <div class="df-center count_down_box" v-if="tryCountDownShow">
                  <van-count-down
                    ref="tryCountDown"
                    millisecond
                    :time="countDownTime"
                    :auto-start="false"
                    format="ss"
                    @finish="finish"
                  />
                  <i>S</i>
                  <span>后可重新发送</span>
                </div>
              </div>
              <template v-if="true">
                <div class="form_row df-item-center">
                  <img
                    src="../../assets/images/applyuse/i-user.png"
                    alt=""
                    class="left_icon"
                  />
                  <van-field
                    v-model="applyUseForm.username"
                    name="username"
                    clearable
                    placeholder="请输入您的姓名"
                    :rules="[{ required: true, message: '' }]"
                  />
                  <!--                <img src="../../assets/images/applyuse/i-arrow-down.png" alt="" class="right_icon">-->
                </div>
                <div
                  class="form_row df-item-center"
                  @click.stop="openRolesPopup(0)"
                >
                  <img
                    src="../../assets/images/applyuse/i-roles.png"
                    alt=""
                    class="left_icon"
                  />
                  <van-field
                    v-model="applyUseForm.roleName"
                    name="roleName"
                    clearable
                    readonly
                    placeholder="请输入您的角色"
                    :rules="[{ required: true, message: '' }]"
                  />
                  <img
                    src="../../assets/images/applyuse/i-arrow-down.png"
                    alt=""
                    class="right_icon"
                  />
                </div>
              </template>

              <div class="form_row df-item-center">
                <img
                  src="../../assets/images/applyuse/i-form4.png"
                  alt=""
                  class="left_icon"
                />
                <van-field
                  v-model="applyUseForm.hospitalName"
                  name="hospitalName"
                  clearable
                  readonly
                  placeholder="请输入医疗机构名称"
                  @click="handleShowPopup(0)"
                  :rules="[{ required: true, message: '' }]"
                />
                <!--                <img src="../../assets/images/applyuse/i-arrow-down.png" alt="" class="right_icon">-->
              </div>
              <div class="submit_btn df-center" @click="submitForm(false)">
                确定
              </div>
              <!--              <div style="margin: 16px;">-->
              <!--                <van-button round block type="info" native-type="submit">提交</van-button>-->
              <!--              </div>-->
            </van-form>
          </van-tab>
          <!--          <img src="" alt="">-->
          <van-tab title="医院购买">
            <van-form
              @submit="onSubmit"
              class="form_padding"
              ref="applyBuyForm"
            >
              <div class="form_row df-item-center" @click="openServicePopup(1)">
                <img
                  src="../../assets/images/applyuse/i-form1.png"
                  alt=""
                  class="left_icon"
                />
                <van-field
                  v-model="applyBuyForm.servicePackageName"
                  name="servicePackageName"
                  readonly
                  placeholder="请选择服务包"
                  :rules="[{ required: true, message: '' }]"
                />
                <img
                  src="../../assets/images/applyuse/i-arrow-down.png"
                  alt=""
                  class="right_icon"
                />
              </div>
              <div class="form_row df-item-center">
                <img
                  src="../../assets/images/applyuse/i-form2.png"
                  alt=""
                  class="left_icon"
                />
                <van-field
                  v-model="applyBuyForm.phone"
                  :placeholder="applyBuyPhoneHolder"
                  type="tel"
                  clearable
                  :rules="[{ required: true, message: '' }]"
                  name="phone"
                />
                <!--                <img src="../../assets/images/applyuse/i-arrow-down.png" alt="" class="right_icon">-->
              </div>
              <div class="form_row df-item-center">
                <img
                  src="../../assets/images/applyuse/i-form3.png"
                  alt=""
                  class="left_icon"
                />
                <van-field
                  v-model="applyBuyForm.validCode"
                  name="validCode"
                  placeholder="请输入验证码"
                  clearable
                  :rules="[{ required: true, message: '' }]"
                />
                <div
                  class="get_code"
                  v-if="!buyCountDownShow"
                  @click="getTryCode(1)"
                >
                  获取验证码
                </div>
                <!--                <van-count-down :time="countDownTime" />-->
                <div class="df-center count_down_box" v-if="buyCountDownShow">
                  <van-count-down
                    ref="buyCountDown"
                    millisecond
                    :time="buyCountDownTime"
                    :auto-start="false"
                    format="ss"
                    @finish="buyFinish"
                  />
                  <i>S</i>
                  <span>后可重新发送</span>
                </div>
              </div>
              <template v-if="true">
                <div class="form_row df-item-center">
                  <img
                    src="../../assets/images/applyuse/i-user.png"
                    alt=""
                    class="left_icon"
                  />
                  <van-field
                    v-model="applyBuyForm.username"
                    name="username"
                    clearable
                    placeholder="请输入您的姓名"
                    :rules="[{ required: true, message: '' }]"
                  />
                  <!--                <img src="../../assets/images/applyuse/i-arrow-down.png" alt="" class="right_icon">-->
                </div>
                <div
                  class="form_row df-item-center"
                  @click.stop="openRolesPopup(1)"
                >
                  <img
                    src="../../assets/images/applyuse/i-roles.png"
                    alt=""
                    class="left_icon"
                  />
                  <van-field
                    v-model="applyBuyForm.roleName"
                    name="roleName"
                    clearable
                    readonly
                    placeholder="请输入您的角色"
                    :rules="[{ required: true, message: '' }]"
                  />
                  <img
                    src="../../assets/images/applyuse/i-arrow-down.png"
                    alt=""
                    class="right_icon"
                  />
                </div>
              </template>
              <div class="form_row df-item-center">
                <img
                  src="../../assets/images/applyuse/i-form4.png"
                  alt=""
                  class="left_icon"
                />
                <van-field
                  v-model="applyBuyForm.hospitalName"
                  name="hospitalName"
                  clearable
                  readonly
                  placeholder="请输入医疗机构名称"
                  @click="handleShowPopup(1)"
                  :rules="[{ required: true, message: '' }]"
                />
                <!--                <img src="../../assets/images/applyuse/i-arrow-down.png" alt="" class="right_icon">-->
              </div>
              <div class="submit_btn df-center" @click="submitForm(false)">
                确定
              </div>
            </van-form>
          </van-tab>
        </van-tabs>
      </div>
      <div class="report_foot">
        <!--   跑马灯     -->
        <van-notice-bar
          left-icon="volume-o"
          :text="noticeBarText"
          background="#fffbe8"
          color="#FC8A55"
          class="notice_bar"
          v-if="step === 0"
        />
        <!-- <div class="foot_tips foot_tips_1">
          温馨提示：填写以上申请表单即可为医院申请开通试用或签约，
          <br>
          2个工作日内会有专属顾问与您联系
        </div> -->
        <div class="foot_tips foot_tips2">
          如遇到困难? 请与我们联系<span @click="callPhone('400-969-7756')"
            >400-969-7756</span
          >
        </div>
      </div>
      <!--  分享提示  -->
      <div
        v-show="isShareTips"
        @click="isShareTips = false"
        class="share-mask"
      ></div>
      <!--   选择服务包-试用   -->
      <van-popup v-model="isChooseServiceShow" round position="bottom">
        <van-picker
          title="请选择服务包"
          show-toolbar
          :columns="servicePackageList"
          @confirm="onConfirm"
          @cancel="onCancel"
          @change="onChange"
          :default-index="0"
        />
      </van-popup>
      <!--   选择服务包-购买   -->
      <van-popup v-model="isChooseServiceBuyShow" round position="bottom">
        <van-picker
          title="请选择服务包"
          show-toolbar
          :columns="servicePackageList"
          @confirm="onConfirm"
          @cancel="onCancel"
          @change="onChange"
          :default-index="applyBuyDefaultIndex"
        />
      </van-popup>
      <!--   选择服务包-试用-角色   -->
      <van-popup v-model="isChooseTryRolesShow" round position="bottom">
        <van-picker
          title="请选择您的角色"
          show-toolbar
          :columns="rolesList"
          @confirm="onConfirmRole"
          @cancel="onCancelRole"
          @change="onChangeRole"
          :default-index="0"
        />
      </van-popup>
      <!--   选择服务包-购买-角色   -->
      <van-popup v-model="isChooseBuyRoleShow" round position="bottom">
        <van-picker
          title="请选择您的角色"
          show-toolbar
          :columns="rolesList"
          @confirm="onConfirmRole"
          @cancel="onCancelRole"
          @change="onChangeRole"
          :default-index="0"
        />
      </van-popup>
      <!--   验证图文二维码弹框   -->
      <van-dialog
        show-cancel-button
        v-model="showValidModal"
        class="shareauth-dialog"
        confirmButtonText="确认"
        confirmButtonColor="black"
        cancelButtonText="取消"
        cancelButtonColor="black"
        title="验证码验证"
        :before-close="beforeColseValidModal"
      >
        <div class="shareauth-validimagebox">
          <div class="shareauth-validimage" @click="getCheckCaptchaCode">
            <van-image
              class="sliderverify-verifyimage"
              ref="verifyImage"
              v-if="imgCode"
              :src="imgCode"
            >
              <template v-slot:error>
                <div style="width: 80px">加载失败</div>
              </template>
            </van-image>
          </div>
          <div class="shareauth-validrefish" @click="getCheckCaptchaCode">
            <span>点击图片刷新</span>
          </div>
        </div>
        <van-field
          v-model="verifyAnswer"
          @focus="vaildImgInfo.errorMsg = ''"
          type="tel"
          center
          clearable
          placeholder="输入计算答案"
        >
          <template #button>
            <div class="van-ellipsis" style="color: #f00">
              {{ vaildImgInfo.errorMsg }}
            </div>
            <!-- <div @click="getValidImageData" class="sliderverify-verifyimage-imagebox">
              <img v-if="vaildImgInfo.sliderImg" :src="vaildImgInfo.sliderImg" />
            </div> -->
          </template>
        </van-field>
        <!-- <div>
          <span style="display: inline-block; padding: 20px">
            您的申请已提交，请耐心等待，也可以联系客服尽快通过审核，
            <a style="color: #1c89ea" :href="'tel:' + kfPhone"
              >点击拨打电话:{{ kfPhone }}</a
            >
          </span>
        </div> -->
      </van-dialog>
      <van-popup v-model:show="isHosPopup" position="bottom" :style="{ height: '100%' }">
        <div class="search-content">
          <div class="searchTtile" :style="{'padding-top':utils.isIphoneX()?'20px':'10px'}">
            <div class="cancelSearch" @click='handleCancel'>取消</div>
            <input class='input' ref="seach_input" @input='handleChange' placeholder="请输入医院名称进行搜索" v-model.trim="searchHosName" type="text">
            <div class="confirmSearch" @click='handleConfirm'>确定选择</div>
          </div>
          <div class="searchList">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
              <van-list
                v-model:loading="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
              >
                <ul v-if='hospitalList.length>0'>
                  <li class='hos-item' v-for="(item, index) in hospitalList" :key="index">
                    <div @click='handleSelectComName(item)'>{{item.comName}}</div>
                    <img v-if='item.isVerify == 1 || item.isVerify == 3' src="../../assets/images/checked.png" alt="">
                  </li>
                </ul>
              </van-list>
            </van-pull-refresh>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import header from "../../components/header/header";
import { DropdownMenu, DropdownItem, Toast ,List, PullRefresh, } from "vant";
import Vue from "vue";
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(List);
Vue.use(PullRefresh);
export default {
  data() {
    return {
      searchHosName:'', // 当前搜索的医院名称
      currentComId:'', // 选择的医院id
      loading:false,
      finished:false,
      refreshing:false,
      isHosPopup:false,
      pageNum:1,
      hospitalList:[], // 医院列表
      headTitle: "申请试用与购买",
      pageName: "applyUse",
      isNavShow: false,
      applyUseIndex: 0,
      step: 0, // 0 选择报告模板 1 设置统计规则
      applyUseForm: {
        // 服务包id
        servicePackageId: "",
        // 服务包名称
        servicePackageName: "",
        // 手机号码
        phone: "",
        // 验证码
        validCode: "",
        // // 姓名
        username: "",
        // 角色id
        roleId: '',
        // // 角色
        roleName: "",
        // 医疗机构名称
        hospitalName: "",
      },
      // 图文二维码
      imgCode: "",
      // 短信检验code
      code: "",
      // 检验验证码token
      token: "",
      isShareTips: false,
      // 申请试用的表单手机号holder
      applyTryPhoneHolder: "请输入手机号",
      // 申请购买的表单手机号holder
      applyBuyPhoneHolder: "请输入手机号",
      // 获取验证码显示吗
      tryCountDownShow: false,
      // 获取验证码显示吗
      buyCountDownShow: false,
      // 验证码类型
      codeType: 0, // 0 试用  1购买
      // 验证码
      vaildImgInfo: {
        errorMsg: "",
      },
      applyBuyForm: {
        // 服务包id
        servicePackageId: "",
        // 服务包名称
        servicePackageName: "",
        // 手机号码
        phone: "",
        // 验证码
        validCode: "",
        // // 姓名
        username: "",
        // 角色id
        roleId: '',
        // // 角色
        roleName: "",
        // 医疗机构名称
        hospitalName: "",
      },
      // 图文二维码弹框
      showValidModal: false,
      // 选择服务包显示
      isChooseServiceShow: false,
      // 选择服务包显示
      isChooseServiceBuyShow: false,
      // 倒计时
      countDownTime: 60 * 1000,
      // 验证码token
      validToken: "",
      // 购买倒计时
      buyCountDownTime: 60 * 1000,
      verifyAnswer: "",
      // 服务包弹框类型
      servicePackageType: 0,
      // // 选择角色显示
      isChooseTryRolesShow: false,
      isChooseBuyRoleShow: false,
      // // 角色类型
      rolesType: 0,
      // 服务包
      // servicePackageList: ['三甲医院服务包', '专科三甲医院服务包', '三级非三甲医院服务包', '二级医院服务包', '一级及以下、未定级医院服务包', '诊所、社区卫生服务中心等基层服务包',
      //   '省级区域感控服务包', '市级区域感控服务包', '区县级区域感控服务包'
      // ],
      servicePackageList: [],
      // 申请试用的版本
      optionRange: [
        {
          text: "全部商品",
          value: 0,
        },
        {
          text: "新款商品",
          value: 1,
        },
        {
          text: "活动商品",
          value: 2,
        },
      ],
      // 申请试用版本号
      applyUserValue: 0,
      noticeBarText: "",
      img: require("../../assets/images/applyuse/i-form1.png"),
      // 服务包类型
      _packageType: "", // 1
      // 默认服务包id
      defaultPackageId: "",
      // 申请购买默认服务包
      applyBuyDefaultIndex: 0,
      // 购买类型
      buyType: "",
      // 角色列表
      rolesList: []
    };
  },
  components: {
    "v-header": header,
  },
  mounted() {
    console.log(this.utils.isIphoneX(),'999');
    // 初始化微信分享
    // this.wxShareInit()
    // 申请购买, 申请试用默认
    this.buyType = this.$route.query.buyType;
    if (this.$route.query && this.$route.query.buyType === "buy") {
      this.applyUseIndex = 1;
    } else {
      this.applyUseIndex = 0;
    }
    // 服务包默认
    if (this.$route.query && this.$route.query.id) {
      this.defaultPackageId = this.$route.query.id;
      console.log(this.$route.query.id, "id......");
    } else {
      this.defaultPackageId = "";
    }
    this.goDefaultTop();
  },
  created() {
    let type = this.$route.query && this.$route.query.type;
    // console.log(type,'7777');
    if (type === "hospital") {
      this._packageType = "1";
    } else if (type === "area") {
      this._packageType = "2";
    }
    this.isHideNavBar();
    document.title = this.$route.meta.title;
    this.initNoticeBarInfo();
    this.getPackageList();
    // 获取角色码表信息
    this.getDictList()
    // this.getCheckCaptchaCode()
  },
  methods: {
    onLoad() {
      if(this.refreshing){
        this.refreshing = false
        this.hospitalList = []
      }
      setTimeout(()=>{
        this.initHoslist();
      },500)
    },
    onRefresh() {
      // 清空列表数据
      this.hospitalList = []
      this.pageNum = 1;
      this.finished = false;
      this.loading = true
      this.onLoad();
    },
    // 输入框发生变化
    handleChange(){
      this.hospitalList = []
      this.pageNum = 1;
      this.finished = false;
      this.loading = true
      setTimeout(()=>{
        this.initHoslist()
      },300)
    },
    // 选择输入的名称
    handleConfirm(){
      if(this.applyUseIndex === 0){
        this.applyUseForm.hospitalName = this.searchHosName
      }else{
        this.applyBuyForm.hospitalName = this.searchHosName
      }
      console.log(this.applyUseForm.hospitalName,'试用');
      console.log(this.applyBuyForm.hospitalName,'购买');
      this.isHosPopup = false
    },
    // 选择已有医院
    handleSelectComName(val){
      this.isHosPopup = false
      if(this.applyUseIndex === 0){
        this.applyUseForm.hospitalName = val.comName
      }else{
        this.applyBuyForm.hospitalName = val.comName
      }
      this.currentComId = val.id
      console.log(this.applyUseForm.hospitalName,'试用');
      console.log(this.applyBuyForm.hospitalName,'购买');
      console.log(this.currentComId,'this.currentComId');
    },
    // 取消选择
    handleCancel(){
      this.isHosPopup = false
      this.handleEmpty()
    },
    handleEmpty(){
      this.searchHosName = ''
      this.applyUseForm.hospitalName = ''
      this.applyBuyForm.hospitalName = ''
      this.currentComId = ''
    },
    handleShowPopup(temp){
      this.pageNum = 1;
      this.finished = false;
      this.loading = true
      this.hospitalList = []
      this.isHosPopup = true
      this.handleEmpty()
      this.initHoslist()
      if(this.utils.isIosOrAndroidOrPc() != 'ios'){
        this.$nextTick(() => {
          this.$refs.seach_input.focus()
        })
      }
    },
    // 医院模糊搜索
    initHoslist: _.throttle(
      function () {
        let params = {
          comName: this.searchHosName,
          page: this.pageNum,
          rows: 20,
        };
        this.$http .searchCompanyByPage(params) .then((res) => {
          if (res.status == 200) {
            this.pageNum++
            this.loading = false
            if(res.hasOwnProperty('data')){
              this.hospitalList = [...this.hospitalList,...res.data]
            }
            if(res.hasOwnProperty('data')&&res.data.length < 20 || res.data == null || !res.hasOwnProperty('data')){
              console.log('进来');
              this.finished = true
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
      },
      300,
      { trailing: false }
    ),
    // 初始化跑马灯信息
    initNoticeBarInfo() {
      const arr = [];
      let str = "";
      for (let i = 0; i < 3000; i++) {
        str = `恭喜1${this.randomNum(3, 9)}${this.randomNum(
          0,
          9
        )}****${this.randomNum(0, 9)}${this.randomNum(0, 9)}${this.randomNum(
          0,
          9
        )}${this.randomNum(0, 9)}获得15天免费试用`;
        arr.push(str);
      }
      const noticeStr = arr.join(",");
      this.noticeBarText = noticeStr;
      // console.log(noticeStr)
    },
    // 下载APP
    goDownAppPath() {
      if (this.buyType === "try") {
        this.cnzzStat(
          "领取15天免费试用权限",
          "路径：领取15天免费试用权限→点击“下载APP”",
          "下载APP(GE_Key_APP_Downloading)"
        );
      } else if (this.buyType === "question") {
        this.cnzzStat(
          "咨询专属顾问",
          "路径：咨询专属顾问→点击“下载APP”",
          "下载APP(CO_Key_APP_Downloading)"
        );
      } else if (this.buyType === "buy") {
        this.cnzzStat(
          "立即购买",
          "路径：立即购买→点击“下载APP”",
          "下载APP(BY_Key_APP_Downloading)"
        );
      }
      this.$router.push("/download/downloadApp");
    },
    // 分享朋友圈
    shareWx() {
      if (this.buyType === "try") {
        this.cnzzStat(
          "领取15天免费试用权限",
          "路径：领取15天免费试用权限→点击“分享至朋友圈”",
          "分享至朋友圈(GE_Key_Wechat_Moments_Sharing)"
        );
      } else if (this.buyType === "question") {
        this.cnzzStat(
          "咨询专属顾问",
          "路径：咨询专属顾问→点击“分享至朋友圈”",
          "分享至朋友圈(CO_Key_Wechat_Moments_Sharing)"
        );
      } else if (this.buyType === "buy") {
        this.cnzzStat(
          "立即购买",
          "路径：立即购买→点击“分享至朋友圈”",
          "分享至朋友圈(BY_Key_Wechat_Moments_Sharing)"
        );
      }
      this.isShareTips = true;
    },
    // 获取角色码表
    getDictList() {
      this.$http.getDictList({classCode: 'REGIS_JOB_LIST'})
        .then(res => {
          if(res.status === 200 && res.data) {
             res.data.forEach(v => v.text = v.dictValue)
             this.rolesList =  res.data
          }
        })
    },
    // 获取服务包列表
    getPackageList() {
      const params = {
        state: 1,
        delFlag: "N",
      };
      if (this._packageType) {
        params.packageType = this._packageType;
      }
      this.$http.getPackagesWhenApply(params).then((res) => {
        if (res.status === 200 && res.data && res.data.length > 0) {
          res.data.forEach((v) => {
            v.text = v.packageName;
          });
          this.servicePackageList = res.data;
          // 默认的服务包
          if (this.defaultPackageId) {
            let defaultIndex = this.servicePackageList.findIndex(
              (v) => v.id === this.defaultPackageId
            );
            console.log(defaultIndex, "找到默认服务包");
            if (defaultIndex !== -1) {
              this.applyBuyDefaultIndex = defaultIndex;
              this.applyBuyForm.servicePackageId = this.servicePackageList[
                defaultIndex
              ].id;
              this.applyBuyForm.servicePackageName = this.servicePackageList[
                defaultIndex
              ].packageName;
            }
          }
        }
        console.log(res);
      });
    },
    // 获取发送短信前的验证码
    getCheckCaptchaCode() {
      this.$http.getCheckCaptchaCode().then((res) => {
        console.log(res);
        this.imgCode = "data:image/png;base64," + res.data.imgBase64;
        this.token = res.data.token;
        console.log(this.imgCode);
      });
    },
    // 校验验证码
    checkCaptchaCode() {
      let params = {
        token: this.token,
        result: this.verifyAnswer,
        phone:
          this.applyUseIndex === 0
            ? this.applyUseForm.phone
            : this.applyBuyForm.phone,
      };
      this.$http.checkCaptchaCode(params).then((res) => {
        console.log(res);
      });
    },
    // 校验短信验证码
    validImgCode() {
      if (this.verifyAnswer.trim().length === 0) {
        this.vaildImgInfo.errorMsg = "验证码不能为空";
        this.showValidModal = true;
        return;
      }
      this.checkCaptchaCode();
    },
    // 发送短信
    sendValidCodeV2() {
      let phone =
        this.applyUseIndex === 0
          ? this.applyUseForm.phone
          : this.applyBuyForm.phone;
      let code = this.$md5(`${phone}3ORefhmwUH5bmWo8Og9tza2JgVI6HB^X`);
      let params = {
        code: code,
        mobile: phone,
        token: this.validToken,
      };
      this.$http
        .sendValidCodeV2(params)
        .then((res) => {
          if (res.data) {
            Toast(res.data);
          } else {
            Toast("发送短信失败, 请勿重复发送");
          }
          // 开始计时
          this.startCountDown(this.applyUseIndex);
          console.log(res);
        })
        .catch((err) => {
          Toast(res.data);
          console.log(err);
        });
    },
    // 校验手机号和验证码
    validPhoneAndImgCode() {
      this.$refs["applyUseForm"]
        .validate("phone")
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          Toast(res.message);
          console.log(err);
        });
    },
    // 微信分享
    wxShareInit() {
      let descs = "因为爱, 所以感控";
      let taskName = "品宣活动首页";
      this.commom.weiXinReady(3, descs, taskName, "", "", "", () => {
        this.isShare = false;
      });
    },
    // 关闭弹框之前
    beforeColseValidModal(action, done) {
      if (action === "confirm") {
        // 校验验证码不为空
        if (this.verifyAnswer.trim().length === 0) {
          this.vaildImgInfo.errorMsg = "验证码不能为空";
          this.showValidModal = true;
          done(false);
          return;
        }
        // 校验验证码的正确性
        let params = {
          token: this.token,
          result: this.verifyAnswer,
          phone:
            this.applyUseIndex === 0
              ? this.applyUseForm.phone
              : this.applyBuyForm.phone,
        };
        this.$http
          .checkCaptchaCode(params)
          .then((res) => {
            if (res.data) {
              this.validToken = res.data;
              // 发送短信
              this.sendValidCodeV2();
              done();
            } else {
              this.vaildImgInfo.errorMsg = "验证失败";
              done(false);
            }
            console.log(res);
          })
          .catch((err) => {
            this.vaildImgInfo.errorMsg = "验证失败";
            done(false);
          });
        // this.checkCaptchaCode()
      } else {
        done();
      }
    },
    // 用户申请
    applyUserInfo() {
      let paramsObj =
        this.applyUseIndex === 0 ? this.applyUseForm : this.applyBuyForm;
      if (this.applyUseIndex === 0) {
        if (this.buyType === "try") {
          this.cnzzStat(
            "领取15天免费试用权限",
            "路径：领取15天免费试用权限→点击“确定”完成申请试用提交",
            "完成申请试用(GE_Submit_Experience_Application)"
          );
        } else if (this.buyType === "question") {
          this.cnzzStat(
            "咨询专属顾问",
            "路径：咨询专属顾问→点击“确定”完成申请试用提交",
            "完成申请试用(CO_Submit_Experience_Application)"
          );
        } else if (this.buyType === "buy") {
          this.cnzzStat(
            "立即购买",
            "路径：立即购买→点击“确定”完成申请试用提交",
            "完成申请试用(BY_Key_Experience_Application)"
          );
        }
      } else {
        if (this.buyType === "try") {
          this.cnzzStat(
            "领取15天免费试用权限",
            "路径：领取15天免费试用权限→点击“确定”完成申请签约提交",
            "完成申请签约(GE_Submit_Buying_Application)"
          );
        } else if (this.buyType === "question") {
          this.cnzzStat(
            "咨询专属顾问",
            "路径：咨询专属顾问→点击“确定”完成申请签约提交",
            "完成申请签约(CO_Submit_Buying_Application)"
          );
        } else if (this.buyType === "buy") {
          this.cnzzStat(
            "立即购买",
            "路径：立即购买→点击“确定”完成申请签约提交",
            "完成申请签约(BY_Key_Buying_Application)"
          );
        }
      }

      let params = {
        mobile: paramsObj.phone,
        comType: paramsObj.servicePackageId,
        comName: paramsObj.hospitalName,
        comeType: 1, // 1 微信  2 线下活动
        purchaseType: this.applyUseIndex === 0 ? 1 : 2, // 1 试用 2 购买
        verifyCode: paramsObj.validCode,
        contact: paramsObj.username,
        contactJob: paramsObj.roleId,
        comId:this.currentComId
      };
      this.$http
        .applyUserInfo(params)
        .then((res) => {
          if (res.status == 200 && res.data == 200) {
            Toast("申请成功");
            this.step = 1;
            return;
          }
          Toast(res.message);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 生成从minNum到maxNum的随机数
    randomNum(minNum, maxNum) {
      switch (arguments.length) {
        case 1:
          return parseInt(Math.random() * minNum + 1, 10);
          break;
        case 2:
          return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
          break;
        default:
          return 0;
          break;
      }
    },
    // 是否隐藏导航栏
    isHideNavBar() {
      const ua = navigator.userAgent.toLowerCase();
      const isWX = ua.match(/MicroMessenger/i) == "micromessenger";
      console.log(isWX);
      this.isNavShow = !isWX;
    },
    // 提交
    onSubmit(values) {
      console.log(values, "提交....");
      let hospitalName = values.hospitalName.trim();
      if (hospitalName.length < 4 || hospitalName.length > 50) {
        Toast("医疗机构名称需在4~50个字符之间");
        return;
      }
      this.applyUserInfo();
    },
    // 获取试用的验证码
    getTryCode(type = 0) {
      this.submitForm(true);
    },
    // 获取验证码计时
    startCountDown(type = 0) {
      this.codeType = type;
      if (type === 0) {
        this.tryCountDownShow = true;
        this.$nextTick(() => {
          this.$refs.tryCountDown.start();
        });
      } else if (type === 1) {
        this.buyCountDownShow = true;
        this.$nextTick(() => {
          this.$refs.buyCountDown.start();
        });
      }
    },
    // 打开服务包选择弹框
    openServicePopup(type = 0) {
      if (type === 0) {
        this.isChooseServiceShow = true;
      } else if (type === 1) {
        this.isChooseServiceBuyShow = true;
      }
      this.servicePackageType = type;
    },
    // 打开角色选择弹框
    openRolesPopup(type = 0) {
      if (type === 0) {
        this.isChooseTryRolesShow = true;
      } else if (type === 1) {
        this.isChooseBuyRoleShow = true;
      }
      this.rolesType = type;
    },
    onConfirm(value, index) {
      console.log(`当前值：${value}, 当前索引：${index}`);
      if (this.servicePackageType === 0) {
        this.applyUseForm.servicePackageName = this.servicePackageList[
          index
        ].text;
        this.applyUseForm.servicePackageId = this.servicePackageList[index].id;
        this.isChooseServiceShow = false;
      } else if (this.servicePackageType === 1) {
        this.applyBuyForm.servicePackageName = this.servicePackageList[
          index
        ].text;
        this.applyBuyForm.servicePackageId = this.servicePackageList[index].id;
        this.isChooseServiceBuyShow = false;
      }
    },
    onChange(picker, value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
    },
    onCancel() {
      this.isChooseServiceShow = false;
      this.isChooseServiceBuyShow = false
      // Toast('取消');
    },
     onConfirmRole(value, index) {
      // console.log(`当前值：${value}, 当前索引：${index}`);
      if (this.rolesType === 0) {
        this.applyUseForm.roleName = this.rolesList[
          index
        ].text;
        this.applyUseForm.roleId = this.rolesList[index].dictCode;
        this.isChooseTryRolesShow = false;
      } else if (this.rolesType === 1) {
        this.applyBuyForm.roleName = this.rolesList[
          index
        ].text;
        this.applyBuyForm.roleId = this.rolesList[index].dictCode;
        this.isChooseBuyRoleShow = false;
      }
    },
    onChangeRole(picker, value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
    },
    onCancelRole() {
      console.log('cancel');
      this.isChooseTryRolesShow = false;
      this.isChooseBuyRoleShow = false
      // Toast('取消');
    },
    // 倒计时结束
    finish() {
      this.tryCountDownShow = false;
      this.$refs.tryCountDown.reset();
    },
    // 购买结束
    buyFinish() {
      this.buyCountDownShow = false;
      this.$refs.buyCountDown.reset();
    },
    // 提交
    submitForm(part = false) {
      const pass = this.validParams();
      if (this.applyUseIndex === 0) {
        if (!pass) {
          this.applyUseForm.phone = "";
          this.applyTryPhoneHolder = "请输入正确的手机号";
        } else {
          this.applyTryPhoneHolder = "请输入手机号";
        }
        // 是局部校验码
        if (part) {
          console.log("局部...");
          this.$refs.applyUseForm
            .validate("phone")
            .then((res) => {
              this.openValidImgCodePopup();
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          // if (this.buyType === "try") {
          //   this.cnzzStat(
          //     "领取15天免费试用权限",
          //     "路径：领取15天免费试用权限→点击“确定”完成申请试用提交",
          //     "完成申请试用(GE_Submit_Experience_Application)"
          //   );
          // } else if (this.buyType === "question") {
          //   this.cnzzStat(
          //     "咨询专属顾问",
          //     "路径：咨询专属顾问→点击“确定”完成申请试用提交",
          //     "完成申请试用(CO_Submit_Experience_Application)"
          //   );
          // } else if (this.buyType === "buy") {
          //   this.cnzzStat(
          //     "立即购买",
          //     "路径：立即购买→点击“确定”完成申请试用提交",
          //     "完成申请试用(BY_Key_Experience_Application)"
          //   );
          // }

          this.$refs.applyUseForm.submit();
        }
      } else {
        if (!pass) {
          this.applyBuyForm.phone = "";
          this.applyBuyPhoneHolder = "请输入正确的手机号";
        } else {
          this.applyBuyPhoneHolder = "请输入手机号";
        }
        if (part) {
          console.log("局部...");
          this.$refs.applyBuyForm
            .validate("phone")
            .then((res) => {
              this.openValidImgCodePopup();
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          // if (this.buyType === "try") {
          //   this.cnzzStat(
          //     "领取15天免费试用权限",
          //     "路径：领取15天免费试用权限→点击“确定”完成申请签约提交",
          //     "完成申请签约(GE_Submit_Buying_Application)"
          //   );
          // } else if (this.buyType === "question") {
          //   this.cnzzStat(
          //     "咨询专属顾问",
          //     "路径：咨询专属顾问→点击“确定”完成申请签约提交",
          //     "完成申请签约(CO_Submit_Buying_Application)"
          //   );
          // } else if (this.buyType === "buy") {
          //   this.cnzzStat(
          //     "立即购买",
          //     "路径：立即购买→点击“确定”完成申请签约提交",
          //     "完成申请签约(BY_Key_Buying_Application)"
          //   );
          // }
          this.$refs.applyBuyForm.submit();
        }
      }
    },
    // 打开校验二维码弹框
    openValidImgCodePopup() {
      this.vaildImgInfo.errorMsg = "";
      this.verifyAnswer = "";
      this.getCheckCaptchaCode();
      this.showValidModal = true;
    },
    // 校验参数
    validParams() {
      let pass = true;
      const reg = /^[1]([2-9])[0-9]{9}$/;
      if (this.applyUseIndex === 0 && this.applyUseForm.phone.length > 0) {
        pass = pass && reg.test(this.applyUseForm.phone);
      } else if (
        this.applyUseIndex === 1 &&
        this.applyBuyForm.phone.length > 0
      ) {
        pass = pass && reg.test(this.applyBuyForm.phone);
      }
      return pass;
    },
  },
};
</script>
<style lang='scss' scoped>
/deep/ .van-field__control{
  font-size: 16px;
}
.apply-use {
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  line-height: 20px;
  background-color: #fff;
  .search-content{
    display: flex;
    flex-direction: column;
    height: 100vh;
    .searchTtile{
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .input{
        padding: 5px;
        width: 60%;
        border: 1px solid #ddd;
        border-radius: 6px;
      }
      /deep/ .van-field{
        padding: 5px;
      }
      .confirmSearch{
          min-width: 80px;
          padding: 6px;
          margin-left: 10px;
          font-size: 14px;
          text-align: center;
          border-radius: 6px;
          background: #039aff;
          color: #fff;
      }
      .cancelSearch{
        margin-right: 20px;
        color: #999;
      }
    }
    .searchList{
      flex: 1;
      overflow: scroll;
    }
    ul{
      .hos-item{
        padding:12px;
        display: flex;
        align-items: center;
        font-size: 16px;
        img{
          margin-left: 3px;
          width: 16vw;
        }
      }
    }
  }

  .container {
    box-sizing: border-box;
    padding: 35px 12px 0;
    padding-top: 70px;

    .report_header {
      position: relative;
      height: 95px;
      opacity: 1;
      background: #ffffff;
      box-shadow: 0px 0px 8px 0px rgba(81, 116, 143, 0.16);

      .circle {
        position: absolute;
        transform: translateX(-50%);
        width: 60px;
        height: 60px;
        left: 50%;
        top: -25px;
        background-color: #fff;
        //background-color: pink;
        border-radius: 50%;
        box-shadow: 0px 0px 8px 0px rgba(81, 116, 143, 0.16);

        img {
          flex-shrink: 0;
          width: 50px;
          height: 50px;
        }
      }

      .step {
        box-sizing: border-box;
        //width: 333px;
        height: 35px;
        opacity: 1;
        position: absolute;
        bottom: 15px;

        .number {
          margin: 0 10px 0 19px;
          flex-shrink: 0;
          width: 18px;
          height: 18px;
          opacity: 1;
          background: #999999;
          border-radius: 50%;
          font-size: 16px;
          color: #ffffff;
        }

        .i-compete {
          margin: 0 10px 0 19px;
          flex-shrink: 0;
          width: 20px;
          height: 20px;
        }

        .text {
          font-size: 16px;
          color: #666666;
        }

        .active_text {
          color: #26b4ff;
        }

        .number_active {
          background: #26b4ff;
        }
        .right_number {
          margin-left: 0;
        }

        img {
          width: 16px;
          height: 16px;
          margin: 0 10px;
          /* margin: 0 10px 0 24px; */
        }
      }
    }

    .share_wx {
      margin-top: 22px;
      height: 293px;
      background: url("../../assets/images/applyuse/bg-compete.png");
      background-size: 100% 100%;
      margin-bottom: 120px;
      box-sizing: border-box;
      padding: 48px 16px 0;

      .share_wx_title {
        font-size: 24px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        color: #333333;
        line-height: 33px;

        span {
          color: #fc8a55;
        }
      }

      .share_btn {
        margin-top: 75px;
        height: 44px;
        opacity: 1;
        background: #ffffff;
        border-radius: 4px;
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        color: #1c91ff;
      }

      .down_app {
        margin-top: 20px;
        color: #ffffff;

        img {
          width: 24px;
          height: 16px;
          margin-right: 7px;
        }
      }
    }

    .report_body {
      margin-top: 15px;
      min-height: 324px;
      box-sizing: content-box;
      opacity: 1;
      background: #ffffff;
      border-radius: 5px;
      box-shadow: 0px 0px 8px 0px rgba(81, 116, 143, 0.16);

      .form_padding {
        box-sizing: border-box;
        padding: 10px 15px 20px;
      }

      .form_row {
        .left_icon {
          width: 20px;
          height: 20px;
          //margin-right: 10px;
        }

        .right_icon {
          width: 18px;
          height: 18px;
        }

        .get_code {
          flex-shrink: 0;
          font-size: 14px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: right;
          color: #26b4ff;
          line-height: 20px;
        }

        border-bottom: 1px solid #eee;
      }

      .submit_btn {
        margin-top: 28px;
        height: 40px;
        opacity: 1;
        background: #26b4ff;
        border-radius: 4px;
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #ffffff;
      }
    }

    .report_foot {
      margin-top: 15px;

      .notice_bar {
        // margin-bottom: 21px;
        // margin-bottom: 41px;
        margin-bottom: 35px;
      }

      .foot_tips {
        font-size: 12px;
        font-family: MicrosoftYaHeiLight;
        text-align: center;
        color: #999999;
        line-height: 16px;

        span {
          margin-left: 5px;
          color: #26b4ff;
        }
      }
    }
  }

  .foot_tips {
    font-size: 12px;
    font-family: MicrosoftYaHeiLight;
    text-align: center;
    color: #999999;
    line-height: 16px;

    span {
      margin-left: 5px;
      color: #26b4ff;
    }
  }

  .foot_tips_1 {
    margin-top: 10px;
    // margin-bottom: 6px;
    text-align: left !important;
  }

  .foot_tips2 {
    padding-bottom: 20px;
  }

  .share-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 12020;
    background-color: rgba(0, 0, 0, 0.6);
    background-image: url(../../assets/images/wechat.png);
    background-repeat: no-repeat;
    background-size: contain;
  }

  .count_down_box {
    color: #999;
    flex-shrink: 0;
    flex-wrap: nowrap;
    i {
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: right;
      color: #26b4ff;
      line-height: 20px;
    }
    span {
      margin-left: 8px;
    }
  }

  .img_code {
    width: 70px;
    height: 30px;
  }

  /deep/ .van-cell {
    padding-left: 10px;
  }

  /deep/ .van-count-down {
    color: #26b4ff;
  }

  .shareauth-dialog {
    padding: 0 15px;
  }

  .shareview-dialog-content {
    padding: 10px 20px;
  }

  .shareauth-validimagebox {
    display: flex;
    margin-top: 10px;

    & > div {
      width: 50%;
    }
  }

  .shareauth-validimage {
    padding: 4px 0 0 0;
  }

  .shareauth-validrefish {
    // padding-right: 15px;
    color: #999;
    text-align: right;
    line-height: 45px;
  }
  /deep/ .van-tab {
    font-size: 16px;
  }
}
</style>
